export default __webpack_public_path__ + "static/media/marker-grey.a3f01d52.svg";